import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../../../components/PageTemplate/PageTemplate';
import InterestedOnYou from '../../../modals/components/layouts/student-dashboard/InterestedOnYou/InterestedOnYou';

export default function InterestedOnYouPage() {
  const { t } = useTranslation();
  return (
    <Grid item lg={6} md={9} xs={12} sx={{ display: { xs: 'block' } }}>
      <PageTemplate
        title={t('left_side_bar.interested_on_you')}
        content={<InterestedOnYou />}
      />
    </Grid>
  );
}
